import { useQueryClient } from '@tanstack/react-query';
import {
  getApiV1PersonIdRolesQueryOptions,
  usePutApiV1PersonIdRoles,
} from '@/shared/api/generated';

/**
 * Mutation para atualizar os vínculos/papéis de uma pessoa via PUT `/api/v1/person/:id/roles`.
 * Invalida o cache de roles após sucesso.
 *
 * @param personId - ID da pessoa
 * @returns Mutation com `mutate({ id, data: UpdatePersonRolesViewModel })`
 *
 * @example
 * ```tsx
 * const update = useUpdatePersonRoles(person.id);
 * update.mutate({ id: person.id, data: { isStudent: true } });
 * ```
 */
export function useUpdatePersonRoles(personId: number) {
  const queryClient = useQueryClient();

  return usePutApiV1PersonIdRoles({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries(getApiV1PersonIdRolesQueryOptions(personId));
      },
    },
  });
}
